"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loadGoogleMaps;
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
const logError = err => /*eslint-disable no-console */
process.env.NODE_ENV === 'development' ? console.error(err) : undefined;
/*eslint-enable no-console */

/**
 * Given a url, will load google maps on the page
 * If a url is not passed in, it'll be assumed google maps has already been loaded and `window.google.maps` exist
 * @param {String} url something like: https://maps.googleapis.com/maps/api/js?key=KEY&amp;language=en&amp;region=US&amp;libraries=places
 * @returns {Promise} - resolves with a google maps reference
 *                    - reject with Error
 */
function loadGoogleMaps(url) {
  return new _promise.default((resolve, reject) => {
    if (window.google && window.google.maps) {
      return resolve(window.google.maps);
    }
    if (!url) {
      logError(`google.maps is not loaded on the page and a url was not provided.
          You may have forgotten to:
          1. Pass in a google maps api "url" prop?
          OR
          2. Add a script tag with google maps to the html
          `);
      return reject(new Error('url is required'));
    }
    const script = window.document.createElement('script');
    script.addEventListener('load', () => {
      if (window.google && window.google.maps) {
        resolve(window.google.maps);
      } else {
        logError('script for google maps loaded but window.google.maps is not available');
        reject(new Error('google.maps is not available'));
      }
    });
    window.document.body.appendChild(script);
    script.src = url;
  });
}